import React, {ChangeEvent, DragEvent, FunctionComponent} from "react";
import FileDropZone from "components/atoms/input/FileDropZone";
import {FileType} from "constants/FileConstants";
import {BookingDocumentFormCategory} from "../../../../interfaces/BookingInterfaces";

interface FileUploadZonesProps {
  category: BookingDocumentFormCategory;
  onFileChange: (file: FileList, fileType: FileType) => void;
}

const FileUploadZones: FunctionComponent<FileUploadZonesProps> = ({
  category,
  onFileChange,
}) => {
  if (category.fileType === FileType.CONFIRMATION) {
    return (
      <>
        <FileDropZone
          label={category.fileLabel}
          handleInputChange={(e: ChangeEvent<HTMLInputElement>) => onFileChange(e.target.files, FileType.CONFIRMATION)}
          handleDrop={(e: DragEvent<HTMLDivElement>) => onFileChange(e.dataTransfer.files, FileType.CONFIRMATION)}
          id="fileZone-confirmation"
          className="me-2"
        />
        <FileDropZone
          label="booking_add_ticket_file"
          handleInputChange={(e: ChangeEvent<HTMLInputElement>) => onFileChange(e.target.files, FileType.TICKET)}
          handleDrop={(e: DragEvent<HTMLDivElement>) => onFileChange(e.dataTransfer.files, FileType.TICKET)}
          id="fileZone-ticket"
          className="me-2"
        />
        <FileDropZone
          label="booking_add_other_file"
          handleInputChange={(e: ChangeEvent<HTMLInputElement>) => onFileChange(e.target.files, FileType.OTHER)}
          handleDrop={(e: DragEvent<HTMLDivElement>) => onFileChange(e.dataTransfer.files, FileType.OTHER)}
          id="fileZone-other"
          className="me-2"
        />
      </>
    );
  }

  return (
    <FileDropZone
      label={category.fileLabel}
      handleInputChange={(e: ChangeEvent<HTMLInputElement>) => onFileChange(e.target.files, category.fileType)}
      handleDrop={(e: DragEvent<HTMLDivElement>) => onFileChange(e.dataTransfer.files, category.fileType)}
      id={`fileZone-${category.idFile}`}
    />
  );
};

export default FileUploadZones;
